module.exports = __webpack_public_path__ + "img/ip6.56eb7849.png";